import { useState } from "react";
import "./demoMotion.css";
import "./demoThemes.css";
import "./demoComplete.css";
import { DemoBrowser, DemoFullFooter } from "./DemoFullParts";

const NAV = ["회원", "콘텐츠", "문의", "권한", "로그"];
const ROWS = [
  { name: "김운영", email: "ops@company.com", role: "Super Admin", status: "ok" },
  { name: "이콘텐츠", email: "cms@company.com", role: "Editor", status: "ok" },
  { name: "박상담", email: "cs@company.com", role: "Support", status: "wait" },
  { name: "최뷰어", email: "view@company.com", role: "Viewer", status: "ok" },
];

function AdminPanel() {
  return (
    <div className="demo-ops__shell" style={{ minHeight: 280 }}>
      <aside className="demo-ops__sidebar">
        {NAV.map((n, i) => (
          <span key={n} className={`demo-ops__nav-item${i === 0 ? " demo-ops__nav-item--on" : ""}`}>
            <span className="demo-ops__nav-dot" />{n}
          </span>
        ))}
      </aside>
      <main className="demo-ops__main">
        <div className="demo-ops__topbar" style={{ marginBottom: "0.65rem" }}>
          <strong style={{ fontSize: "0.82rem" }}>회원 관리</strong>
          <div className="demo-ops__search">🔍 검색…</div>
        </div>
        <div className="demo-ops__table-wrap">
          <table>
            <thead><tr><th>이름</th><th>권한</th><th>상태</th></tr></thead>
            <tbody>
              {ROWS.map((r) => (
                <tr key={r.email}>
                  <td>{r.name}</td>
                  <td>{r.role}</td>
                  <td><span className={`demo-ops__badge demo-ops__badge--${r.status}`}>{r.status === "ok" ? "활성" : "대기"}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}

export default function AdminPageDemo({ embed = false }) {
  const [toast, setToast] = useState(true);

  return (
    <div
      className={`demo-root demo-ops${embed ? " demo-root--embed" : ""}`}
      data-testid="portfolio-demo-admin-page"
      style={{
        "--accent": "#06b6d4",
        "--bg": "#0a1018",
        "--muted": "#64748b",
        "--border": "#1e293b",
        "--card": "#0f1724",
        "--section-alt": "#070d14",
        position: "relative",
      }}
    >
      {toast && (
        <div className="demo-ops__toast">
          문의 #1042 처리 완료
          <button type="button" onClick={() => setToast(false)} style={{ marginLeft: 8, background: "none", border: "none", color: "inherit", cursor: "pointer" }}>×</button>
        </div>
      )}

      <header className="demo-full__nav">
        <div style={{ fontWeight: 800, color: "#06b6d4" }}>OpsHub</div>
        <nav className="demo-full__nav-links">
          <span>기능</span>
          <span>보안</span>
          <span>연동</span>
          <span>요금</span>
        </nav>
        <span className="demo-full__nav-cta" style={{ background: "#06b6d4", color: "#0a1018" }}>도입 문의</span>
      </header>

      <section className="demo-full__hero">
        <div className="demo-full__hero-grid">
          <div>
            <span className="demo-full__eyebrow">Internal Operations Console</span>
            <h1 style={{ color: "#e2e8f0" }}>
              회원·콘텐츠·문의를
              <br />
              한 콘솔에서
            </h1>
            <p className="demo-full__hero-lead">
              서비스 운영팀을 위한 관리자 시스템. Role 기반 권한, 티켓 처리,
              활동 로그까지 실무에 필요한 기능을 웹에서 바로 처리합니다.
            </p>
            <div className="demo-full__hero-btns">
              <span className="demo-full__btn demo-full__btn--primary" style={{ background: "#06b6d4", color: "#0a1018" }}>라이브 데모</span>
              <span className="demo-full__btn demo-full__btn--secondary">기능 목록</span>
            </div>
          </div>
          <DemoBrowser url="admin.opshub.io" accent="#06b6d4">
            <AdminPanel />
          </DemoBrowser>
        </div>
      </section>

      <section className="demo-full__section demo-full__section--alt">
        <div className="demo-full__wrap">
          <div className="demo-full__grid3">
            {[
              { icon: "👤", t: "회원·권한", d: "Role 기반 접근 제어와 감사 추적." },
              { icon: "📋", t: "콘텐츠 CMS", d: "배너·공지·페이지 운영자 직접 수정." },
              { icon: "💬", t: "문의 티켓", d: "미처리 문의 상태별 관리·배정." },
            ].map((f) => (
              <article key={f.t} className="demo-full__card">
                <div className="demo-full__card-icon">{f.icon}</div>
                <h3 style={{ color: "#e2e8f0" }}>{f.t}</h3>
                <p>{f.d}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="demo-full__section">
        <div className="demo-full__wrap">
          <div className="demo-full__statbar">
            {[
              { v: "1,248", l: "관리 회원" },
              { v: "5", l: "권한 Role" },
              { v: "-50%", l: "처리 시간" },
              { v: "100%", l: "활동 로그" },
            ].map((s) => (
              <div key={s.l} className="demo-full__statbar-item">
                <strong style={{ color: "#06b6d4" }}>{s.v}</strong>
                <span>{s.l}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="demo-full__section demo-full__section--alt">
        <div className="demo-full__wrap">
          <div className="demo-full__head">
            <h2 style={{ color: "#e2e8f0" }}>엔터프라이즈 보안</h2>
          </div>
          <div className="demo-full__steps">
            {[
              { n: "🔒", t: "RBAC", d: "역할 기반 권한 분리" },
              { n: "📜", t: "Audit Log", d: "모든 변경 이력 추적" },
              { n: "🔑", t: "SSO", d: "Google·Azure AD 연동" },
              { n: "🛡", t: "2FA", d: "관리자 2단계 인증" },
            ].map((s) => (
              <div key={s.t} className="demo-full__step">
                <div className="demo-full__step-num" style={{ background: "#0f1724", border: "1px solid #1e293b", fontSize: "1rem" }}>{s.n}</div>
                <h4 style={{ color: "#e2e8f0" }}>{s.t}</h4>
                <p>{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div style={{ padding: "0 1.5rem 3rem", maxWidth: 1100, margin: "0 auto", textAlign: "center" }}>
        <h2 style={{ margin: "0 0 0.5rem", color: "#e2e8f0" }}>운영 규모에 맞는 관리자 시스템</h2>
        <p style={{ margin: "0 0 1.25rem", color: "#64748b" }}>요구사항 기반 맞춤 개발 및 기존 서비스 연동.</p>
        <span className="demo-full__btn demo-full__btn--primary" style={{ background: "#06b6d4", color: "#0a1018" }}>상담 신청</span>
      </div>

      <DemoFullFooter
        brand="OpsHub"
        desc="내부 운영자를 위한 관리자 콘솔 · Enterprise Ready"
        columns={[
          { title: "Product", links: ["Admin", "CMS", "Tickets", "Analytics"] },
          { title: "Security", links: ["RBAC", "Audit", "SSO", "Compliance"] },
          { title: "Contact", links: ["ops@opshub.io", "Enterprise Sales", "Documentation"] },
        ]}
        copy="© 2026 OpsHub. All rights reserved."
      />
    </div>
  );
}
